import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
	ButtonComponent,
	CardComponent,
	DatalayerService,
	DeferLoadDirective,
	NotificationType,
	IconCircleComponent,
	PaddingSize, WINDOW_PROVIDERS
} from '@woolworthsnz/styleguide';
import { getRecipePath } from '../../helpers/recipe-path';
import { PrepSummaryMode, PrepSummaryComponent } from '../prep-summary/prep-summary.component';
import { Stamp, StampType } from '../../models';
import { saveButtonAriaLabel } from '../../helpers';
import { QuantitySelectorComponent } from '@woolworthsnz/product';
import { BadgeComponent } from '../badge/badge.component';
import { MealTimesComponent } from '../meal-times/meal-times.component';
import { NgClass, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
	selector: 'recipe-stamp',
	templateUrl: './stamp.component.html',
	styleUrls: ['./stamp.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [WINDOW_PROVIDERS],
	standalone: true,
	imports: [CardComponent, RouterLink, NgClass, DeferLoadDirective, NgIf, MealTimesComponent, PrepSummaryComponent, BadgeComponent, ButtonComponent, IconCircleComponent, QuantitySelectorComponent]
})
export class StampComponent {
	@Input() stamp: Stamp;
	@Input() stampType: StampType = StampType.recipe;
	@Input() initialServings = 1;
	@Input() useCustomActions = false;

	@Output() save = new EventEmitter<number>();
	@Output() addServing = new EventEmitter<{ stamp: Stamp; quantity: number }>();
	@Output() removeServing = new EventEmitter<{ stamp: Stamp; quantity: number }>();
	@Output() stampClick = new EventEmitter();

	padding = PaddingSize.None;
	prepMode = PrepSummaryMode.Summary;
	imageLoading = true;

	constructor(private datalayerService: DatalayerService) { }

	get recipePath(): string {
		return getRecipePath(this.stamp.recipe.mealTimes, this.stamp.recipe.title, this.stamp.recipe.id);
	}

	get fallbackImageUrl(): string {
		return `/images/recipe_unavailable.svg`;
	}

	get saveButtonText(): string {
		return saveButtonAriaLabel(this.stamp.recipe.title, !!this.stamp.recipe.saved);
	}

	get labelledBy(): string {
		return `recipe-${this.stamp.recipe.id}-title recipe-${this.stamp.recipe.id}-mealTimes recipe-${this.stamp.recipe.id}-prepSummary`;
	}

	saveClick(): void {
		this.datalayerService.trackRecipeEvent(NotificationType.Button, 'RSTAMP_save_icon', this.stamp.recipe.id);
		this.save.emit(this.stamp.recipe.id);
	}

	handleStampClick(): void {
		this.datalayerService.trackRecipeEvent(NotificationType.Stamp, 'RSTAMP', this.stamp.recipe.id);
		this.stampClick.emit();
	}

	handleAddServing(stamp: Stamp, quantity: number): void {
		this.addServing.emit({ stamp, quantity });
	}

	handleRemoveServing(stamp: Stamp, quantity: number): void {
		this.removeServing.emit({ stamp, quantity });
	}

	isMealPlanStamp(): boolean {
		return this.stampType === StampType.meal;
	}
}
